/* unplugin-vue-components disabled */import script from "./item-detile.vue?vue&type=script&setup=true&lang=ts"
export * from "./item-detile.vue?vue&type=script&setup=true&lang=ts"

import "./item-detile.vue?vue&type=style&index=0&id=c9b287c6&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c9b287c6"]])

export default __exports__